const late_train = `Aihe: Junan myöhästymistä koskeva valitus
Joita se voi koskettaa,
Kirjoitan ilmaistakseni syvän turhautumiseni äskettäisen junamatkani VR:n kanssa merkittävästä viivästymisestä.
Juna, johon nousin [päivämäärä], saapui määränpäähäni 45 minuuttia aikataulusta myöhässä,
aiheuttaa minun myöhästymisen tärkeästä kokouksesta.
Tämä viivästys vaikutti merkittävästi ammatillisiin sitoumuksiini,
seurauksena menetetyt mahdollisuudet ja mahdolliset taloudelliset seuraukset.
Lisäksi se aiheutti tarpeetonta stressiä ja vaivaa,
häiritsevät huolellisesti suunniteltuani päiväohjelmaani.
Tämän tilanteen valossa
Kehotan VR:tä ryhtymään välittömiin toimenpiteisiin junaliikenteen täsmällisyyden parantamiseksi ja sen varmistamiseksi, ettei tällaisia merkittäviä viivästyksiä tapahdu jatkossa.
Parempien ylläpitokäytäntöjen käyttöönotto ja tehokkaampien aikatauluprotokollien noudattaminen voi auttaa vähentämään tällaisten häiriöiden esiintymistiheyttä ja ylläpitämään palvelujesi luotettavuutta.
Arvostan nopeaa huomiotasi tähän asiaan ja luotan siihen, että tarvittavat toimenpiteet toteutetaan vastaavien tapausten toistumisen estämiseksi.
Ystävällisin terveisin`;
export default late_train;